// utils/timeUtils.js — Conversion UTC → timezone entreprise
import { DateTime } from 'luxon';

/**
 * Convertit une heure UTC (depuis heure_utc backend) en heure locale de l'entreprise
 * @param {string} utcString  — ex: "2026-03-30T13:47:17Z"
 * @param {string} timezone   — ex: "Africa/Brazzaville" | "Europe/Paris"
 * @returns {string}          — ex: "14:47"
 */
export const formatHeureLocale = (utcString, timezone = 'Africa/Brazzaville') => {
  if (!utcString) return '-';
  try {
    return DateTime.fromISO(utcString, { zone: 'utc' })
      .setZone(timezone)
      .toFormat('HH:mm');
  } catch (e) {
    console.error('formatHeureLocale error:', e);
    return '-';
  }
};